import React from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { useHistory } from "react-router-dom";
import Header from "../../../components/molecules/Header";
import Gap from "../../../components/Gap";
import ListItemMap from "./ListItem";
// material
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import useStyles from "./style";

function RewardList() {
  const classes = useStyles();
  const history = useHistory();
  const { point, kredit, penukaran } = useData();
  const combineList = (penukaran_reward, poin_reward) => {
    if ((penukaran_reward.length && poin_reward.length) > 0) {
      return penukaran_reward.concat(poin_reward);
    } else if (penukaran_reward.length > 0) {
      return penukaran_reward;
    } else if (poin_reward.length > 0) {
      return poin_reward;
    } else {
      return [];
    }
  };

  const gabunganPenukaranPoin = combineList(penukaran ?? [], point ?? []);

  const PointAll = (point ?? []).reduce(function (prev, curr) {
    return prev + curr.nilai;
  }, 0);

  // const PenukaranApproved = (penukaran ?? []).reduce(function (prev, curr) {
  //   if (curr.status === "approved") {
  //     return prev + curr.total_penukaran_reward;
  //   }
  //   return prev;
  // }, 0);
  // const PenukaranPending = (penukaran ?? []).reduce(function (prev, curr) {
  //   if (curr.status === "pending") {
  //     return prev + curr.total_penukaran_reward;
  //   }
  //   return prev;
  // }, 0);

  const PenukaranAll =
    (kredit?.total_penukaran_reward_approved ?? 0) +
    (kredit?.total_penukaran_reward_pending ?? 0);

  const MyPoints = PointAll - PenukaranAll;

  return (
    <>
      <Header
        title="Reward Saya"
        onClick={() => history.goBack()}
        type="with-title"
      />
      <div
        className={classes.hero}
        style={{
          backgroundColor: "#F5F5F5",
        }}
      >
        <Gap height={20} />
        <div className={classes.wrapHeader}>
          <Typography className={classes.liquidSecond}>
            Total Poin Saya
          </Typography>
          <Typography className={classes.liquidTitle}>
            {MyPoints.toString()}
          </Typography>
        </div>
        <div className={classes.wrapCard}>
          <Card>
            <CardContent>
              <Grid container justify="space-evenly">
                <Grid item className={classes.wrapGrid}>
                  <Typography className={classes.liquidPrimary}>
                    Total Berhasil
                  </Typography>
                  <Typography className={classes.liquidSecond}>
                    {(kredit?.total_penukaran_reward_approved ?? 0).toString()}
                  </Typography>
                </Grid>
                <Grid item className={classes.wrapGrid}>
                  <Typography className={classes.liquidPrimary}>
                    Total Pending
                  </Typography>
                  <Typography className={classes.liquidSecond}>
                    {(kredit?.total_penukaran_reward_pending ?? 0).toString()}
                  </Typography>
                </Grid>
              </Grid>
              <Gap height={10} />
              <Divider />
              <Gap height={10} />
              <div className={classes.wrapBtnList}>
                <CardActions>
                  <Button
                    fullWidth
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={() => history.push("/akun/rewardpoint")}
                  >
                    Tukar Reward
                  </Button>
                </CardActions>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      <div className={classes.wrapList}>
        <List
          subheader={
            <ListSubheader disableSticky={true}>
              Riwayat Penukaran Reward
            </ListSubheader>
          }
        >
          {gabunganPenukaranPoin.length > 0 ? (
            gabunganPenukaranPoin
              .sort(
                (a, b) => b?.created_at?.toMillis() - a?.created_at?.toMillis()
              )
              .map((v, i) => {
                return <ListItemMap key={i} data={v} />;
              })
          ) : (
            <Typography>Tidak Ada data</Typography>
          )}
        </List>
      </div>
    </>
  );
}

export default RewardList;
